import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint,
  desktop_container_maxwidth_compact,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const HomeDetailsStyles = styled.div`
  padding-top: 25px;
  min-height: 550px;

  .bottom-page-container {
    background-color: ${Colors.accent.grey7.standard};
    .bottom-page-info {
      margin: 0 auto;
      width: 86%;
    }
  }
  .disclaimer {
    font-size: 12px;
    margin: 20px auto;
    padding: 0;
  }
  #imageDisclaimer {
    margin: ${(props) =>
      props.$hasVirtualTour ? '-2px 0 0 145px' : '-2px auto 0'};
    width: ${(props) => (props.$hasVirtualTour ? '150px' : 'auto')};
  }
  .stock-indicator {
    .in-stock-dot {
      background-color: ${Colors.secondary.kiddiePool.standard};
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin: 4px 3px 4px 2px;
      display: inline-block;
      line-height: 0.6;
    }
  }
  .slideshow-container {
    margin-bottom: 80px;
  }
  .features-container {
    margin-bottom: 60px;
    margin-top: 20px;
  }
  .features-container-empty {
    margin-bottom: 20px;
  }
  .request-form {
    .modal-container {
      width: 95%;
      z-index: 99999;
    }
  }
  .disclaimer-content {
    padding: 20px 0;
    width: 100%;
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    #imageDisclaimer {
      width: auto;
    }
    .bottom-page-info {
      max-width: 512px;
    }
    .request-form {
      .modal-container {
        width: 45%;
        max-width: 527px;
        min-width: 320px;
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    #imageDisclaimer {
      margin: -10px auto;
      width: auto;
    }
    .bottom-page-info {
      max-width: 1100px;

      > div {
        width: 100%;
        margin: 0;
      }
    }
    .request-form {
      .modal-container {
        width: 30%;
        max-width: 527px;
        min-width: 388px;
      }
    }
    .constrained-width {
      max-width: ${desktop_container_maxwidth_compact}px;
    }
  }
`;

export default HomeDetailsStyles;
